// Sliders

import slick from 'slick-carousel';
import $ from 'jquery';

if ($('.slick-carousel--home-hero').length > 0) {
    $('.slick-carousel--home-hero').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true,
        dotsClass: 'list list--inline slick-dots',
        autoplay: 3000
    });
}

if ($('.slick-carousel--partners').length > 0) {
    $('.slick-carousel--partners').on('init', function () {
        $('.slick-carousel--partners').attr('data-equalizer', 'slick--partners');
        $('.slide--partners').attr('data-equalizer-watch', 'slick--partners');
    });
}

if ($('.slick-carousel--partners').length > 0) {
    $('.slick-carousel--partners').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        nextArrow: '<button class="slick-next slick-arrow slick-arrow--partners"><span class="fas fa-arrow-right"></span></button>"',
        prevArrow: '<button class="slick-prev slick-arrow slick-arrow--partners"><span class="fas fa-arrow-left"></span></button>"',
        mobileFirst: true,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    });
}

if ($('.slick-carousel--project-progress').length > 0) {
    $('.slick-carousel--project-progress').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        dotsClass: 'slick-dots slick-dots--project-progress list list--inline',
        nextArrow: '<button class="slick-next slick-arrow slick-arrow--project-progress"><span class="fas fa-arrow-right"></span></button>"',
        prevArrow: '<button class="slick-prev slick-arrow slick-arrow--project-progress"><span class="fas fa-arrow-left"></span></button>"',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}
